import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { AddCommaNumber } from "../../../helpers/Utils";
import { Row } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import moment from "moment";

const CustomerAnalytics = (props) => {
  const { new_customers, returning_customers, top_spenders, setting } = props;

  return (
    <div>
      {/* Top Spenders Table */}
      {/* <h5 className='mt-4 mb-2'>Top khách hàng chi tiêu cao</h5> */}
      <ReactTable
        defaultPageSize={10}
        data={top_spenders?.data || []}
        columns={[
          {
            Header: <IntlMessages id="analytics.table.stt" />,
            accessor: "stt",
            width: 10,
            Cell: (row) => <div className="text-center">{row.value}</div>,
          },
          {
            Header: <IntlMessages id="analytics.customer.name" />,
            accessor: "name",
            Cell: (row) => (
              <div
                className={`text-center ${row.original.is_anonymous ? "font-italic text-muted" : ""}`}
              >
                {row.value}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.customer.phone" />,
            accessor: "phone",
            Cell: (row) => (
              <div
                className={`text-center ${row.original.is_anonymous ? "text-muted" : ""}`}
              >
                {row.value}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.customer.order_count" />,
            accessor: "order_count",
            Cell: (row) => <div className="text-center">{row.value}</div>,
          },
          {
            Header: <IntlMessages id="analytics.customer.products_purchased" />,
            accessor: "products_purchased",
            Cell: (row) => <div className="text-center">{row.value}</div>,
          },
          {
            Header: <IntlMessages id="analytics.customer.total_spent" />,
            accessor: "total_spent",
            Cell: (row) => (
              <div className="text-center text-primary font-weight-bold">
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.customer.point" />,
            accessor: "point",
            Cell: (row) => (
              <div className="text-center text-warning">{row.value}</div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.customer.debt" />,
            accessor: "debt",
            Cell: (row) => (
              <div
                className={`text-center ${row.value > 0 ? "text-danger font-weight-bold" : ""}`}
              >
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.customer.created_at" />,
            accessor: "createdAt",
            Cell: (row) => (
              <div className="text-center">
                {row.value ? moment(row.value).format("HH:mm DD/MM/YYYY") : "-"}
              </div>
            ),
          },
        ]}
        minRows={0}
        showPageJump={false}
        showPageSizeOptions={false}
        PaginationComponent={Pagination}
        NoDataComponent={() => (
          <div className="text-center text-muted py-3">
            <IntlMessages id="analytics.customer.no_data" />
          </div>
        )}
        getTrProps={(state, rowInfo) => {
          if (rowInfo && rowInfo.original.is_anonymous) {
            return {
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.03)",
              },
            };
          }
          return {};
        }}
        className="equal-columns-table"
      />
    </div>
  );
};

export default CustomerAnalytics;
